import { useEffect, useState } from 'react'

import '../css/Navbar.css'
import { apiURL } from '../utilities/URLs'
import { affiliateData, company } from '../data/AffiliateData'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '../ThemeContext'
import { refreshAccessToken } from '../utilities/extensions'

export default function Account() {
  const navigate = useNavigate()
  const { isDarkMode } = useTheme()
  
  const [selectedTab, setSelectedTab] = useState(0)

  const [accountName, setAccountName] = useState(affiliateData.account.accountName)
  const [accountEmail, setAccountEmail] = useState(affiliateData.account.accountEmail)
  const [accountPhone, setAccountPhone] = useState(affiliateData.account.accountPhone)

  const [newPassword, setNewPassword] = useState('')
  const [confirmNewPassword, setConfirmNewPassword] = useState('')

  const [userName, setUserName] = useState('')
  const [userEmail, setUserEmail] = useState('')
  const [userPassword, setUserPassword] = useState('')
  const [userPhone, setUserPhone] = useState('')
  const [userCreated, setUserCreated] = useState(false)

  const [error, setError] = useState('')

  useEffect(() => {
    document.title = `${company.companyName} | Account`
  }, [])

  const handleUpdateAccount = async () => {
    if(accountName.length > 0 && accountEmail.length > 0) {
      const accountInfo = {
        accountId: affiliateData.account.accountId,
        accountType: affiliateData.account.accountType,
        accountName: accountName,
        accountEmail: accountEmail,
        accountPhone: '+1'+accountPhone.replace(/\D/g, '')
      }

      const formData = new FormData()
      formData.append('accountInfo', JSON.stringify(accountInfo))

      const updatedAccountResponse = await fetch(`${apiURL}/api/updateAccount`, {
        method: 'PUT',
        body: formData,
        headers: {
          'Authorization': affiliateData.accessToken
        }
      })

      const updatedAccountData = await updatedAccountResponse.json()
      if(updatedAccountData.response.error) {
        if(updatedAccountData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          refreshedToken && refreshedToken.length > 0 ? await handleUpdateAccount() : navigate('/affiliate', { state: { expired: true }})
        } else {
          setError(updatedAccountData.response.error)
          setTimeout(() => {
            setError('')
          }, 2000)
        }
      }
      else {
        affiliateData.updateAccountDetails(accountName, accountEmail, accountPhone)
        setError('Updated Account!')
        setTimeout(() => {
          setError('')
        }, 2000)
      }
    } else {
      setError('Missing Fields')
      setTimeout(() => {
        setError('')
      }, 2000)
    }
  }

  const handleUpdatePassword = async () => {
    if(newPassword === confirmNewPassword) {
      const accountInfo = {
        accountId: affiliateData.account.accountId,
        accountType: affiliateData.account.accountType,
        accountPassword: newPassword
      }

      const formData = new FormData()
      formData.append('accountInfo', JSON.stringify(accountInfo))

      const updatedAccountPasswordResponse = await fetch(`${apiURL}/api/updateAccountPassword`, {
        method: 'PUT',
        body: formData,
        headers: {
          'Authorization': affiliateData.accessToken
        }
      })

      const updatedAccountPasswordData = await updatedAccountPasswordResponse.json()
      if(updatedAccountPasswordData.response.error) {
        if(updatedAccountPasswordData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          refreshedToken && refreshedToken.length > 0 ? await handleUpdatePassword() : navigate('/affiliate', { state: { expired: true }})
        } else {
          setError(updatedAccountPasswordData.response.error)
          setTimeout(() => {
            setError('')
          }, 2000)
        }
      } else {
        setError('Password Updated!')
        setNewPassword('')
        setConfirmNewPassword('')
        setTimeout(() => {
          setError('')
        }, 2000)
      }
    } else {
      setError('Passwords do not match')
      setTimeout(() => {
        setError('')
      }, 2000)
    }
  }

  const handleAddUser = async () => {
    if(userName.length > 0 && userEmail.length > 0 && userPassword.length > 0) {
      const userInfo = {
        affiliateId: affiliateData.account.accountId,
        userName: userName,
        userEmail: userEmail,
        userPassword: userPassword,
        userPhone: '+1'+userPhone.replace(/\D/g, '')
      }

      const formData = new FormData()
      formData.append('userInfo', JSON.stringify(userInfo))

      const addUserResponse = await fetch(`${apiURL}/api/addUserToAffiliate`, {
        method: 'POST',
        body: formData,
        headers: {
          'Authorization': affiliateData.accessToken
        }
      })

      const addUserData = await addUserResponse.json()
      if(addUserData.response.error) {
        if(addUserData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          refreshedToken && refreshedToken.length > 0 ? await handleAddUser() : navigate('/affiliate', { state: { expired: true }})
        } else {
          setError(addUserData.response.error)
          setTimeout(() => {
            setError('')
          }, 2000)
        }
      }
      else {
        setUserName('')
        setUserEmail('')
        setUserPassword('')
        setUserPhone('')
        setUserCreated(true)
        setTimeout(() => {
          setUserCreated(false)
        }, 2000)
      }
    } else {
      setError('Missing Fields')
      setTimeout(() => {
        setError('')
      }, 2000)
    }
  }

  const handleLogout = async () => {
    const clearCookieResponse = await fetch(`${apiURL}/api/clearCookie`)
    const clearCookieData = await clearCookieResponse.json()
    if(clearCookieData.response.error)
      console.error(clearCookieData.response.error)
    else {
      localStorage.removeItem('affiliateAccessToken')
      navigate('/affiliate')
    }
  }

  return (
    <div className={`account w-screen h-full flex flex-col items-center font-mont text-center ${isDarkMode && 'bg-[#1a1d21]'}`}>
      <h1 className={`accountHeader text-3xl font-bold mb-10 mt-10 ${isDarkMode && 'text-white'}`}>Account</h1>
      {affiliateData.account.accountType === 'affiliate' && (
        <div className='accountTabBar w-full flex flex-row justify-center gap-5 text-sm'>
          <button
            className={`btn-underline ${selectedTab === 0 ? 'active text-primaryColor' : `${isDarkMode && 'text-white'}`} hover:text-primaryColor`}
            onClick={() => setSelectedTab(0)}>
            Account Info
          </button>
          <button
            className={`btn-underline ${selectedTab === 1 ? 'active text-secondaryColor' : `${isDarkMode && 'text-white'}`} hover:text-secondaryColor`}
            onClick={() => setSelectedTab(1)}>
            Add User
          </button>
        </div>
      )}
      {selectedTab === 0 ? (
        <div className='flex flex-col items-center'>
          <div className='accountInfoTab mt-10 flex lg:flex-row max-sm:flex-col justify-between'>
            <div className='flex flex-col items-center'>
              <div className='lg:pr-4'>
                <div className='mb-4'>
                  <h2 className={`text-left font-bold mb-2 ${isDarkMode && 'text-white'}`}>Name</h2>
                  <input 
                    className={`w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${isDarkMode && 'bg-gray-800 text-white'}`}
                    name='name'
                    value={accountName}
                    readOnly
                  />
                </div>
            
                <div className='mb-4'>
                  <h2 className={`text-left font-bold mb-2 ${isDarkMode && 'text-white'}`}>Email</h2>
                  <input 
                    className={`w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${isDarkMode && 'bg-gray-800 text-white'}`}
                    name='email'
                    type='email'
                    value={accountEmail}
                    onChange={(e) => setAccountEmail(e.target.value)}
                  />
                </div>
            
                <div className='mb-4'>
                  <h2 className={`text-left font-bold mb-2 ${isDarkMode && 'text-white'}`}>Phone</h2>
                  <input 
                    className={`w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${isDarkMode && 'bg-gray-800 text-white'}`}
                    name='phone'
                    type='tel'
                    value={accountPhone}
                    onChange={(e) => setAccountPhone(e.target.value)}
                  />
                </div>
              </div>
              <div className='flex flex-col mt-10 lg:mr-5'>
                <button className='px-4 py-2 bg-secondaryColor text-white rounded hover:bg-secondaryPrimaryColor focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50' onClick={() => handleUpdateAccount()}>
                  Update Account
                </button>
                <button className='mt-2 px-4 py-2 bg-primaryColor text-white rounded hover:bg-primaryDarkColor focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50' onClick={() => handleLogout()}>
                  Log Out
                </button>
              </div>
            </div>

            <div className='border-r-2 border-gray-300'></div>
          
            <div className='flex flex-col items-center max-sm:mt-10'>
              <div className='lg:pl-4'>
                <div className='mb-4'>
                  <h2 className={`text-left font-bold mb-2 ${isDarkMode && 'text-white'}`}>New Password</h2>
                  <input 
                    className={`w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${isDarkMode && 'bg-gray-800 text-white'}`}
                    name='newPassword'
                    type='password'
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </div>
            
                <div className='mb-4'>
                  <h2 className={`text-left font-bold mb-2 ${isDarkMode && 'text-white'}`}>Confirm New Password</h2>
                  <input 
                    className={`w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${isDarkMode && 'bg-gray-800 text-white'}`}
                    name='confirmPassword'
                    type='password'
                    value={confirmNewPassword}
                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                  />
                </div>
              </div>
              <button className='px-4 py-2 mt-5 lg:ml-2 max-sm:mb-5 bg-blue-500 text-white rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50' onClick={() => handleUpdatePassword()}>
                Update Password
              </button>
            </div>
          </div>
          {error.length > 0 && (
            <p className='mt-5 text-red-500'>{error}</p>
          )}
        </div>
      ) : (
        <div className='createUserTab flex items-center justify-center mt-10'>
          <div className={`p-8 rounded-lg shadow-lg min-w-[320px] ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
            <h2 className={`text-2xl font-semibold text-center mb-6 ${isDarkMode && 'text-white'}`}>Add User</h2>
              <div className='mb-4'>
                <label htmlFor='userName' className={`block text-sm font-medium text-left ${isDarkMode ? 'text-white' : 'text-gray-700'}`}>Name</label>
                <input type='text' id='userName' name='userName' required placeholder='John Doe' value={userName} onChange={(e) => setUserName(e.target.value)}
                      className={`mt-1 p-2 w-full border rounded-md shadow-sm focus:ring focus:ring-opacity-50 focus:ring-indigo-300 ${isDarkMode && 'bg-gray-800 text-white'}`}/>
              </div>
              <div className='mb-4'>
                <label htmlFor='userEmail' className={`block text-sm font-medium text-gray-700 text-left ${isDarkMode ? 'text-white' : 'text-gray-700'}`}>Email</label>
                <input type='email' id='userEmail' name='userEmail' required placeholder='johndoe@example.com' value={userEmail} onChange={(e) => setUserEmail(e.target.value)}
                      className={`mt-1 p-2 w-full border rounded-md shadow-sm focus:ring focus:ring-opacity-50 focus:ring-indigo-300 ${isDarkMode && 'bg-gray-800 text-white'}`}/>
              </div>
              <div className='mb-4'>
                <label htmlFor='userPassword' className={`block text-sm font-medium text-gray-700 text-left ${isDarkMode ? 'text-white' : 'text-gray-700'}`}>Password</label>
                <input type='password' id='userPassword' name='userPassword' required placeholder='secretpassword123' value={userPassword} onChange={(e) => setUserPassword(e.target.value)}
                      className={`mt-1 p-2 w-full border rounded-md shadow-sm focus:ring focus:ring-opacity-50 focus:ring-indigo-300 ${isDarkMode && 'bg-gray-800 text-white'}`}/>
              </div>
              <div className='mb-6'>
                <label htmlFor='userPhone' className={`block text-sm font-medium text-gray-700 text-left ${isDarkMode ? 'text-white' : 'text-gray-700'}`}>Phone Number</label>
                <input type='tel' id='userPhone' name='userPhone' placeholder='+11234567890' value={userPhone} onChange={(e) => setUserPhone(e.target.value)}
                      className={`mt-1 p-2 w-full border rounded-md shadow-sm focus:ring focus:ring-opacity-50 focus:ring-indigo-300 ${isDarkMode && 'bg-gray-800 text-white'}`}/>
              </div>
              <div className='text-center'>
                <button onClick={() => handleAddUser()} className='px-4 py-2 bg-primaryColor text-white rounded hover:bg-primaryDarkColor focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50'>
                  Add User
                </button>
                {error.length > 0 && (
                  <p className='mt-5 text-red-500'>{error}</p>
                )}
                {userCreated && (
                  <p className={`mt-5 ${isDarkMode && 'text-white'}`}>User Created!</p>
                )}
              </div>
          </div>
        </div>
      )}
    </div>
  )
}